import Link from 'next/link';
export const EmptyList = ({
  title,
  text,
  buttonLink,
  buttonText,
}: {
  title?: string;
  text: string;
  buttonLink?: string;
  buttonText?: string;
}) => {
  return (
    <div className="empty-profile-showcase py-10 flex flex-col items-center content-center gap-5 w-full">
      {title && <h2 className="text-3xl font-bold text-primary">{title}</h2>}
      <p className="text-2xl">{text}</p>
      <img
        src="/images/emptyShowcase.svg"
        alt="Empty showcase - STC"
        className="min-w-full max-w-full h-64 m-2 lg:m-9"
      />

      {buttonLink && (
        <Link href={buttonLink}>
          <a>
            <button className="btn-new">{buttonText}</button>
          </a>
        </Link>
      )}
    </div>
  );
};
